import React, { useEffect, useState } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import moment from "moment";

// utils //
import { saveForm, getToken } from "../../../services/formServices";

// Components //
import FormBodyPreAceleradora from "../form-body-pre-aceleradora/FormBodyPreAceleradora";
import ResultFormPreCEID from "../../organisms/pre-ceid-success-result/ResultFormPreCEID";
import TitleSection from "../../molecules/title-section";
import ArrowRigth from "../../atoms/icons/ArrowRigth";
import FormResult from "../form-result/formResult";
import Button from "../../atoms/button/button";

// Styles
import "./preAceleradoraCard.scss";

type AceleradoraCardProps = {
    tituloPrincipal?: string;
    tituloFormulario?: string;
    descripcionFormulario?: any;
    tituloUbicacion?: string;
    titulosFormulario: Array<any>;
    metaTitulo: string;
    modalSuccess: any;
    modalError: any;
    modalDeshabilitar: any;
};

function PreAceleradoraCard(props: AceleradoraCardProps) {
    const defaultFormValues = {
        document_type: "",
        complete_name: "",
        cellphone: "",
        docNumber: "",
        email: "",
        dataProcessingAuthorization: "",
        additionalCellphone: "",
    };

    const [formValues, setFormValues] = useState(defaultFormValues);
    // cuando se renderiza el grupo todos los inputs obligatorios son agregados a una lista
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [isDisabledButton, setDisabledButton] = useState<boolean>(false);
    const [inputDisabled] = useState<string[]>([]);
    const [fieldsToSkip] = useState<string[]>([]);
    const [isOpenModalSucces, setIsOpenModalSucces] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);

    const contentfulModalSuccess = props.modalSuccess;
    const contentfulModalError = props.modalError;

    useEffect(() => {
        const timer = setTimeout(() => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
        }, 100);

        return () => clearTimeout(timer);
    }, [activeIndex]);

    //Validaciones para los inputs
    const inputRegexValidation = (field: any, value: any) => {
        // Evita que el usuario incluya caracteres no alfabeticos
        if (field === "nameContact" || field === "role") {
            const re = /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g;
            return re.test(value);
        } else if (field === "phone") {
            return value.length <= 10 ? true : false;
        }
        return true;
    };

    const updateInputValue = (field: string, value: any, type?: string) => {
        if (inputRegexValidation(field, value)) {
            setFormValues((prev: any) => {
                return { ...prev, [field]: value };
            });
        }
    };

    const createPayload = () => {
        const payload: any = {
            idForm: 11,
            answers: [],
        };

        Object.entries(formValues).forEach(([key, value]) => {
            // Transformar valor de true a "Si"
            if (key === "dataProcessingAuthorization") {
                value = "Si";
            }
            payload.answers.push({ contentfulId: key, answer: value });
        });

        // add register Date
        payload.answers.push({
            contentfulId: "registerDate",
            answer: moment(Date.now()).format("DD-MM-YYYY"),
        });
        return payload;
    };

    const handleSubmitForm = async () => {
        setDisabledButton(true);
        try {
            const payload = createPayload();
            const token = await getToken();
            const response = await saveForm(payload, token);
            handleModalContent(response.data.status);
        } catch (error) {
            console.log(error);
            setIsError(true);
        } finally {
            setDisabledButton(false);
        }
    };

    // Guarda en un estado con el contenido de los modales que se renderizan al finalizar el formulario
    const handleModalContent = (status: number) => {
        if (status === 200 || status === 201) {
            setIsOpenModalSucces(true);
            setIsError(false);
            handleDataLayerPush();
        } else {
            setIsError(true);
        }
    };

    const handleBackPreviusStep = () => {
        if (activeIndex > 0) {
            setActiveIndex(activeIndex - 1);
        }
    };

    const handleDataLayerPush = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'confirmacionEnvioExitosoFormulario',
            'envioformulario': `enviar_pre_registro_centro_de_empleo`
        });
    };

    const handleResetForm = () => {
        setIsOpenModalSucces(false);
        setIsError(false);
        setActiveIndex(0);
        setActiveIndex(0);
        setDisabledButton(false);
    };

    //  Renderiza pagina de error
    if (isError && contentfulModalError) {
        return (
            <div className="m-pre-aceleradora-succes-container">
                <FormResult
                    image={contentfulModalError.imagenPrincipal[0]}
                    title={contentfulModalError.tituloBanner}
                    titleDescription={
                        contentfulModalError?.tituloDescripcion ?? ""
                    }
                    titleButton={contentfulModalError.tituloBoton}
                    buttonUrl={"#"}
                    description={documentToReactComponents(
                        JSON.parse(contentfulModalError?.descripcion.raw) ?? {}
                    )}
                    fixedDescription={documentToReactComponents(
                        JSON.parse(contentfulModalError?.descripcionFija.raw) ??
                            {}
                    )}
                    onClickButton={handleResetForm}
                />
            </div>
        );
    }

    //  Renderiza el alerta de formulario enviado exitosamente.
    if (isOpenModalSucces) {
        return <ResultFormPreCEID alertContent={contentfulModalSuccess} />;
    }

    return (
        <div className="m-pre-aceleradora-card">
            {activeIndex > 0 ? (
                <Button
                    classname="m-pre-aceleradora-card__header__back"
                    type={"button"}
                    text={"Volver"}
                    isDisabled={undefined}
                    onClickAction={handleBackPreviusStep}
                >
                    <ArrowRigth />
                </Button>
            ) : null}

            <div className="m-pre-aceleradora-card__header">
                <TitleSection type="h1" title={props?.tituloPrincipal || ""} />
            </div>
            <div className="m-pre-aceleradora-card__body">
                <div className="m-pre-aceleradora-card__body__content">
                    <FormBodyPreAceleradora
                        // Campos y estilos del formulario
                        activeIndex={activeIndex}
                        setActiveIndex={setActiveIndex}
                        titulosFormulario={props.titulosFormulario}
                        genericClassNameForm={props.metaTitulo}
                        setInputValue={updateInputValue}
                        formValues={formValues}
                        handleSubmitForm={handleSubmitForm}
                        inputDisabled={inputDisabled}
                        isDisabledButton={isDisabledButton}
                        fieldsToSkip={fieldsToSkip}
                        modalDeshabiltar={props.modalDeshabilitar}
                    ></FormBodyPreAceleradora>
                </div>
            </div>
        </div>
    );
}

export default PreAceleradoraCard;
